import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-8 bg-surface border-y border-white/5" data-id="element-338">
      <div className="container mx-auto px-4" data-id="element-339">
        {/* Stats Bar */}
        <FadeIn data-id="element-340">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-8" data-id="element-341">
            <div className="flex flex-col items-center text-center px-4" data-id="element-342">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-343">
                👨‍👩‍👧‍👦
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-344">
                +1.200
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-345">
                Familias
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-346">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-347">
                📖
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-348">
                6
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-349">
                Módulos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-350">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-351">
                🎁
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-352">
                4
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-353">
                Bonos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-354">
              <div className="flex gap-1 mb-3" data-id="element-355">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-lg" data-id="element-356">
                    ★
                  </span>)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-357">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-358">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6" data-id="element-359">
          <FadeIn delay={0.1} data-id="element-360">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-361">
              <div className="flex gap-1 mb-4" data-id="element-362">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-363">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-364">
                "En tres días de usar el Protocolo Sin Palabras, mi hijo dejó de
                encerrarse sin decir nada. No lo podía creer."
              </p>
              <div className="flex items-center gap-3" data-id="element-365">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-366">
                  M
                </div>
                <div data-id="element-367">
                  <p className="font-bold text-white text-sm" data-id="element-368">Marcela G.</p>
                  <p className="text-xs text-gray-500" data-id="element-369">Córdoba</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-370">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-371">
              <div className="flex gap-1 mb-4" data-id="element-372">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-373">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-374">
                "El Módulo de Ansiedad 911 fue exactamente lo que necesitaba
                para los ataques de pánico de mi hija antes de los exámenes.
                Concreto, práctico y funciona."
              </p>
              <div className="flex items-center gap-3" data-id="element-375">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-376">
                  L
                </div>
                <div data-id="element-377">
                  <p className="font-bold text-white text-sm" data-id="element-378">Laura P.</p>
                  <p className="text-xs text-gray-500" data-id="element-379">Rosario</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-380">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-381">
              <div className="flex gap-1 mb-4" data-id="element-382">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-383">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-384">
                "Tenía 15 años sin poder hablar más de 5 minutos con mi hijo sin
                que termine en grito. El Plan de 30 Días cambió todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-385">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-386">
                  R
                </div>
                <div data-id="element-387">
                  <p className="font-bold text-white text-sm" data-id="element-388">Roberto M.</p>
                  <p className="text-xs text-gray-500" data-id="element-389">Buenos Aires</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}